var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 87.1100 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.7051-27.6855C76.9043-27.6855 80.2734-31.0547 80.2734-35.2539C80.2734-39.4531 76.9043-42.8223 72.7051-42.8223C68.5547-42.8223 65.1367-39.4531 65.1367-35.2539C65.1367-31.0547 68.5547-27.6855 72.7051-27.6855Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5547-27.6855C47.7539-27.6855 51.123-31.0547 51.123-35.2539C51.123-39.4531 47.7539-42.8223 43.5547-42.8223C39.3555-42.8223 35.9863-39.4531 35.9863-35.2539C35.9863-31.0547 39.3555-27.6855 43.5547-27.6855Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4043-27.6855C18.6035-27.6855 21.9727-31.0547 21.9727-35.2539C21.9727-39.4531 18.6035-42.8223 14.4043-42.8223C10.2051-42.8223 6.83594-39.4531 6.83594-35.2539C6.83594-31.0547 10.2051-27.6855 14.4043-27.6855Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.22954b876a858d4e3d883600cb79cbd3.svg";
export { ForwardRef as ReactComponent };